<button class="m-button"
        :class="{ 'm--is-skin-primary': isSkinPrimary,
               'm--is-skin-secondary': isSkinSecondary,
               'm--is-skin-tertiary': isSkinTertiary,
               'm--is-waiting': isWaiting,
               'm--is-disabled': disabled,
               'm--is-full-size': fullSize }"
        :disabled="disabled || isWaiting"
        :type="type"
        @click="onClick"
        @mousedown="onMousedown"
        @focus="onFocus"
        @blur="onBlur"
        @touchstart="onTouchstart"
        @touchend="onTouchend">
    <m-icon v-if="hasIconLeft"
            aria-hidden="true"
            class="m-button__icon m--is-left"
            :name="iconName"
            :size="iconSize"
    />
    <m-spinner v-if="hasWaitingIconLeft"
               aria-hidden="true"
               class="m-button__icon m--is-left"
               skin="lighter"
               size="small"
    />
    <span class="m-button__text">
        <slot />
        <span class="m-button__precision"
              v-if="hasPrecision">
            <slot name="precision"></slot>{{precision}}
        </span>
    </span>
    <m-spinner v-if="hasWaitingIconRight"
               aria-hidden="true"
               class="m-button__icon m--is-right"
               skin="lighter"
               size="small"
    />
    <m-icon v-if="hasIconRight"
            aria-hidden="true"
            class="m-button__icon m--is-right"
            :name="iconName"
            :size="iconSize"
    />
</button>
